import { useMutatePatientHealthData } from './useMutatePatientHealthData.hook'

export const usePatientHealthDataSubscribers = () => {
  useMutatePatientHealthData()
}
